import React from "react";
import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Button,
  Paper,
} from "@mui/material";
import {
  controlAllFeatureOptions,
  featureOptionDisplayLabels,
} from "../../../configs/constants";

const Reusable = ({
  label,
  options = [],
  selected,
  onChange,
  onSave,
  multi = false,
   showButton = true,
}) => {
  const isObject = typeof selected === "object" && !Array.isArray(selected);
  const isArray = Array.isArray(selected);
  const isSingle = !isObject && !isArray;

  return (
    <Paper elevation={2} sx={{ p: 3,mt:3, width: "100%", border: "1px solid #ccc" }}>
      <Typography fontWeight={700} fontSize={24} mb={3} fontFamily="Aeonik">
        {label}
      </Typography>

      <FormGroup row sx={{ color: "#7B8499", gap:7 }}>
        {options.map((option) => {
          const opt = String(option);
          const mappedFeatureValue = controlAllFeatureOptions?.[opt];
          const value =
            mappedFeatureValue
              ? mappedFeatureValue
              : opt === "Sip_OfferType"
              ? "sip_offertype"
              : opt === "Sip_Luckey_Draw"
                ? "sip_luckey_draw"
                : opt === "Multi_Winner_Lucky_Draw"
                  ? "multi_winner_lucky_draw"
                : opt.includes("_")
                  ? opt.toLowerCase()
                  : opt.toLowerCase();

          let isChecked = false;

          if (isObject) {
            isChecked = selected[value];
          } else if (isArray) {
            isChecked = selected.includes(value);
          } else {
            isChecked = selected === value;
          }

          return (
            <FormControlLabel
              key={option}
              control={
                <Checkbox
                  checked={!!isChecked}
                  onChange={(e) => {
                    if (isObject) {
                      onChange({ ...selected, [value]: e.target.checked });
                    } else if (isArray) {
                      if (e.target.checked) {
                        if (!selected.includes(value)) {
                          onChange([...selected, value]);
                        }
                      } else {
                        onChange(selected.filter((v) => v !== value));
                      }
                    } else {
                      onChange(value); // toggles between "true" / "false" or other
                    }
                  }}
                  sx={{
                    color: "#7b8499",
                    "&.Mui-checked": {
                      color: "#4caf50",
                    },
                  }}
                />
              }
              label={
                <Typography
                  variant="body2"
                  fontFamily="Inter"
                  fontSize="14px"
                  fontWeight="500"
                  color="#7b8499"
                >
                  {featureOptionDisplayLabels[opt] || option}
                </Typography>
              }
            />
          );
        })}
      </FormGroup>
       {showButton && (
        <Button
          variant="contained"
          onClick={onSave}
          sx={{ bgcolor: "#752ADA", px: 6, textTransform: "none", mt: 3 }}
        >
          Save
        </Button>
      )}
    </Paper>
  );
};

export default Reusable;
